import styled from 'styled-components'

export const Root = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: end;
  float: left;
  width: 100%;
`

export const Wrapper = styled.div`
  align-items: baseline;
  display: flex;
`

export const TextWrapper = styled.div`
  align-items: center;
  display: flex;
  margin-bottom: 10px;
`

export const Dates = styled.div`
  align-items: center;
  display: flex;
  flex-direction: row;
  justify-content: center;
  flex-wrap: wrap;
`
